import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAudit } from "@/components/AuditContext";
import { CTAButton } from "@/components/CTAButton";
import { SERVICES, SERVICE_ORDER } from "@/lib/servicesData";
import { METIERS, METIER_ORDER } from "@/lib/metiersData";
import { LOCAL_PAGES, LOCAL_ORDER } from "@/lib/localData";
import { COMPANY } from "@/lib/content";

export const Footer = () => {
  const { openAudit } = useAudit();
  return (
    <footer className="bg-navy-dark text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <Logo variant="dark" markClassName="h-10" textClassName="text-2xl" />
            <p className="mt-6 text-slate-300 leading-relaxed max-w-sm">
              L'infogérance tout compris des entreprises des Hauts-de-France, jusqu'à 20 postes
              et au-delà. Un seul interlocuteur, une seule facture.
            </p>
            <div className="mt-8"><CTAButton onClick={openAudit} withArrow data-testid="footer-audit-cta">Réserver un échange gratuit</CTAButton></div>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-display text-sm uppercase tracking-widest text-amber-500 mb-5">Navigation</h4>
            <ul className="space-y-3 text-slate-300">
              <li><Link to="/" className="hover:text-white transition-colors">Accueil</Link></li>
              <li><Link to="/offres" className="hover:text-white transition-colors">Offres</Link></li>
              <li><Link to="/pourquoi-umbo-cyber" className="hover:text-white transition-colors">Pourquoi Umbo</Link></li>
              <li><Link to="/guide" className="hover:text-white transition-colors">Le guide</Link></li>
              <li><Link to="/actualites" className="hover:text-white transition-colors">Actualités</Link></li>
              <li><Link to="/partenaires" className="hover:text-white transition-colors">Partenaires</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display text-sm uppercase tracking-widest text-amber-500 mb-5">Services</h4>
            <ul className="space-y-3 text-slate-300">
              {SERVICE_ORDER.map((slug) => (
                <li key={slug}><Link to={`/${slug}`} className="hover:text-white transition-colors">{SERVICES[slug].navLabel}</Link></li>
              ))}
              {METIER_ORDER.map((slug) => (
                <li key={slug}><Link to={`/${slug}`} className="hover:text-white transition-colors">Informatique · {METIERS[slug].navLabel}</Link></li>
              ))}
              {LOCAL_ORDER.filter((slug) => LOCAL_PAGES[slug].footer).map((slug) => (
                <li key={slug}><Link to={`/${slug}`} className="hover:text-white transition-colors">{LOCAL_PAGES[slug].navLabel}</Link></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display text-sm uppercase tracking-widest text-amber-500 mb-5">Contact</h4>
            <ul className="space-y-4 text-slate-300">
              <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-amber-500 shrink-0" /><a href={`tel:${COMPANY.phoneHref}`} className="hover:text-white transition-colors">{COMPANY.phone}</a></li>
              <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-amber-500 shrink-0" /><a href={`mailto:${COMPANY.email}`} className="hover:text-white transition-colors">{COMPANY.email}</a></li>
              <li className="flex items-start gap-3"><MapPin className="w-4 h-4 text-amber-500 shrink-0 mt-1" /><span>679 avenue de la République,<br />59800 Lille — Hauts-de-France</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-sm text-slate-400">
          <p>© {new Date().getFullYear()} {COMPANY.legalName} — Tous droits réservés.</p>
          <div className="flex flex-wrap gap-6">
            <Link to="/mentions-legales" className="hover:text-white transition-colors">Mentions légales</Link>
            <Link to="/politique-de-confidentialite" className="hover:text-white transition-colors">Politique de confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
